import * as timeago from 'timeago.js';
import it_locale from "timeago.js/esm/lang/it";
import doc_ready from 'document-ready';

export function init() {
    timeago.register('it-IT', it_locale);
    doc_ready(() => {
        let timeago_dates = document.querySelectorAll('.timeago-date');
        if (timeago_dates.length > 0)
            timeago.render(timeago_dates, 'it-IT');
    })
}
